import { createApi } from '@thinknimble/tn-models'
import { axiosInstance } from '../axios-instance'
import { createExpenseSearchShape, expenseSearchFilterShape, expenseSearchShape } from './models'

export const expenseSearchApi = createApi({
  client: axiosInstance,
  baseUri: '/expenses/expense-searches/',
  models: {
    entity: expenseSearchShape,
    create: createExpenseSearchShape,
    extraFilters: expenseSearchFilterShape,
  },
})
